<template>
  <div>
    <el-dialog v-model="learningEvaluateShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="header"></div>
        <div class="close_icon cursor_pointer">
          <el-icon :size="20" @click="closePopup">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="flex mar_top_20 general_comment FlexBetween">
          <div class="flex">
            <div class="red_xing">*</div>
            <div class="mar_left_5">回复内容</div>
          </div>
          <div class="red_xing" v-if="evaluateInfo.content.length > 0 && evaluateInfo.content.length < 5">
            至少输入5个字
          </div>
        </div>
        <div class="input_box mar_top_15">
          <el-input v-model="evaluateInfo.content" maxlength="300"
            style="width: 100%; height: 250px; background: rgb(238, 237, 237);border-radius: 5px;"
            placeholder="可以从课程内容组织、授课方式的角度评价课程，或者分享课程给你带来了什么收获和启发" type="textarea" autosize />
        </div>
        <div class="btn_box mar_top_25 flex Flexalign FlexjustifyEnd">
          <div class="btn_cancel cursor_pointer" @click="closePopup">取消</div>
          <div class="btn_confirm mar_left_15 cursor_pointer" @click="submitEvaluate">
            提交
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcLearningEvaluate",

  data() {
    return {
      learningEvaluateShow: false,
      evaluateInfo: {
        sceneId: "",
        scene: "",
        content: "",
        imgs: "",
      },
      submitFlag:false,   // 用于处理重复点击
    };
  },

  mounted() { },

  methods: {
    closePopup() {
      this.evaluateInfo.content = "";
      this.learningEvaluateShow = false;
    },
    // 提交评价
    submitEvaluate() {
      if(this.submitFlag) return;
      if (!this.evaluateInfo.content) {
        this.$Dialog.toast("请输入回复内容", { type: "warning" });
        return;
      }
      if (this.evaluateInfo.content.length > 0 && this.evaluateInfo.content.length < 5) {
        this.$Dialog.toast("至少输入5个字", { type: "warning" });
        return;
      }
      this.submitFlag = true;
      if (this.evaluateInfo.scene == 1 || this.evaluateInfo.scene == 2) {
        this.$Api.course
          .addReply(this.evaluateInfo)
          .then((res) => {
            console.log(res);
            this.$Dialog.toast("回复成功");
            this.$emit("refreshGetList");
            this.closePopup();
          })
          .catch(() => {
            this.submitFlag = false;
          });
      } else if (this.evaluateInfo.scene == 3) {
        let params = {
          targetReplyId: this.evaluateInfo.sceneId,
          content: this.evaluateInfo.content,
          imgs: this.evaluateInfo.imgs,
        };
        this.$Api.course
          .addReplyToReply(params)
          .then((res) => {
            console.log(res);
            this.$Dialog.toast("回复成功");
            this.$emit("refreshGetList");
            this.closePopup();
          })
          .catch(() => {
            this.submitFlag = false;
            // this.closePopup();
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  width: 696px;
  // height: 600px;
  background: #f5f6f8;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

:deep(.el-dialog__header) {
  position: relative;
  // padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
  padding: 0;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  height: 50px;
  //   border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 0;
  color: #333333;
}

.dialog_content {
  .study_feel {
    font-size: 20px;
    color: #333333;
  }

  .general_comment {
    color: #333333;

    .red_xing {
      color: #ea2f15;
    }
  }

  .rate_box {
    color: #999999;

    :deep(.el-rate .el-rate__icon) {
      font-size: 22px;
    }

    :deep(.el-rate .el-rate__icon.is-active) {
      color: rgba(237, 120, 60, 1);
      font-size: 26px;
    }
  }

  .input_box {
    :deep(.el-textarea__inner) {
      box-shadow: none;
      resize: none;
      padding: 20px;
      box-sizing: border-box;
      background: rgb(238, 237, 237);
    }
  }

  .btn_box {
    .btn_cancel {
      width: 94px;
      height: 36px;
      border-radius: 18px;
      border: 1px solid #606060;
      font-size: 18px;
      color: #606060;
      line-height: 36px;
      text-align: center;
    }

    .btn_confirm {
      width: 94px;
      height: 36px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
    }
  }
}
</style>
